import React, { Component } from 'react';
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer'
import Loading from '../../components/common/Loading';
import NoData from '../../components/common/NoData';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../../Config/FbConfig';
import { Styles } from "../styles/Faculties";

export default class Librarian extends Component {

  state = { Datas: [] }

  //Load Data Here
  async componentDidMount() {
    const docRef = doc(firestore, "Library", "LibraryStaff");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      var Data = []
      Object.entries(docSnap.data()).forEach(([key, value]) => {
        Data.push(Object.assign({ Id: key, Priority: value.Priority != undefined ? value.Priority : "999" }, value))
      });
      Data.sort(function (a, b) { return a.Priority - b.Priority; });
      Data.length === 0 ?
        this.setState({ Datas: "NO_999" }) :
        this.setState({ Datas: Data })
    } else {
      this.setState({
        Datas: "NO_999"
      })
    }
  }

  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Librarian and Faculties" image="banner/library-2.jpg" />

        <section className="ttm-row aboutus-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-4 res-991-mt-40 res-991-text-center">
                <div className="position-relative res-991-mt-30">
                  <div className="ttm_single_image-wrapper">
                    <img className="img-fluid" src={process.env.PUBLIC_URL + "/assets/images/home/librarian.jpg"} alt="single-img-eighteen" />
                  </div>
                </div>
              </div>
              <div className="col-lg-8 justify" style={{ margin: "auto" }}>
                <div className="section-title with-desc clearfix">
                  <div className="title-header"><h3 className="title">LIBRARIAN <span>MESSAGE</span></h3></div>
                  <div className="title-desc"><p>The main aim of the Library is to provide the right documents to the right users at the right time The Library mission is to enable the staff and students of the central Library to engage optimally with the over-changing information environment in order to succeed in their research, learning, and teaching goals. It has a compressive collection to meet the needs of its users. The Library holdings include a diverse collection of print, non-print computer resources for all users. The Library is fully computerized with Library management software Libsoft 12.0.0 version. It helps in accessing a wide range of materials, both in print and electronic version. I invite you to visit the Library in order to enjoy the wealth of information resources available in the Library in various forms.</p></div>
                </div>
                <h4>Dr.Venkatesh.G</h4>
                <p style={{ fontSize: "1rem", paddingTop: "0.25rem" }}>Librarian</p>
                <div className="ttm-team-data paddingtop-2">
                  <div className="ttm-team-details-wrapper">
                    <ul className="ttm-team-details-list clearfix">
                      <li>
                        <div className="ttm-team-list-title"><i className="ti ti-calendar" /> Qualification :</div>
                        <div className="ttm-team-list-value">M.L.I.Sc, M.Phil., Ph.D.</div>
                      </li>
                      <li>
                        <div className="ttm-team-list-title"><i className="ti ti-world" /> Experience :</div>
                        <div className="ttm-team-list-value">14 Years</div>
                      </li>
                      <li>
                        <div className="ttm-team-list-title"><i className="ti ti-time" /> Skills :</div>
                        <div className="ttm-team-list-value">ICT, Resources Sharing, Information Literacy</div>
                      </li>
                      <li>
                        <div className="ttm-team-list-title"><i className="ti ti-email" /> Phone :</div>
                        <div className="ttm-team-list-value">7795323103</div>
                      </li>
                      <li>
                        <div className="ttm-team-list-title"><i className="ti ti-email" /> Email :</div>
                        <div className="ttm-team-list-value">venkateshkinc@gmail.com</div>
                      </li>
                      <li>
                        <div className="ttm-team-list-title"><i className="ti ti-location-pin" /> Profile :</div>
                        <div className="ttm-team-list-value"><a href={process.env.PUBLIC_URL + "/assets/pdf/librarian.pdf"} target="_blank" style={{ color: "#98002e", fontWeight: "bold" }}>Click Here</a></div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="container">
          <div className="section-title with-desc text-left clearfix">
            <div className="title-header" style={{ borderTopColor: "red" }}>
              <h3 className="title">Library Staff</h3>
            </div>
          </div>
          <Styles>
            <div className="row">
              {
                this.state.Datas.length === 0 ? <Loading /> :
                  this.state.Datas === "NO_999" ? <NoData /> :
                    this.state.Datas.map((data, i) => (
                      <div className="col-md-3 ttm-box-col-wrapper d-flex align-items-stretch" key={i} style={{ marginBottom: "1rem" }}>
                        <div className="featured-imagebox featured-imagebox-blog">
                          <div className="featured-thumbnail" style={{ height: "20rem" }}>
                            <img className="img-fluid" alt="" src={data.Image} />
                          </div>
                          <div className="featured-content" style={{ marginTop: "-1.5rem" }}>
                            <div className="post-meta">
                              <h6 style={{ fontWeight: "bold", fontSize: "14px", color: "#98002e" }}>{data.Name}</h6><br />
                              <small dangerouslySetInnerHTML={{ __html: data.Description.replaceAll("\\n", "<br/>") }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
              }
            </div>
          </Styles>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    )
  }
}
